import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'Psihoterapie 1 la 1',
    href: '#servicii'
  }, {
    name: 'Resurse Gratuite',
    href: 'https://drive.google.com/drive/folders/11ZxZCHf5GnWI5fZ7Zw6EKIx8bJ2hd7kh?usp=sharing'
  }, {
    name: 'Despre mine',
    href: '#despre'
  }];
  return <nav className="sticky top-0 z-50 w-full bg-brand-bg/90 backdrop-blur-md border-b border-brand-primary/10" data-id="element-204">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="flex justify-between items-center h-20" data-id="element-206">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-207">
            <a href="#" className="font-serif text-2xl font-bold text-brand-primary" data-id="element-208">
              Daniela Sămărtinean
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-209">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-text hover:text-brand-primary transition-colors font-medium text-sm" data-id="element-210">
                {link.name}
              </a>)}
            <a href="https://wa.me/40742236028" data-id="element-211">
              <Button variant="accent" size="sm" data-id="element-212">
                Rezervă Sesiunea
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-213">
            <button onClick={() => setIsOpen(!isOpen)} className="text-brand-text hover:text-brand-primary p-2" aria-label="Toggle menu" data-id="element-214">
              {isOpen ? <X size={24} data-id="element-215" /> : <Menu size={24} data-id="element-216" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-brand-bg border-b border-brand-primary/10" data-id="element-217">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-218">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-2 text-base font-medium text-brand-text hover:text-brand-primary hover:bg-brand-secondary/10 rounded-md" onClick={() => setIsOpen(false)} data-id="element-219">
                {link.name}
              </a>)}
            <div className="pt-4" data-id="element-220">
              <a href="https://wa.me/40742236028" data-id="element-221">
                <Button variant="accent" fullWidth onClick={() => setIsOpen(false)} data-id="element-222">
                  Rezervă Sesiunea
                </Button>
              </a>
            </div>
          </div>
        </div>}
    </nav>;
}